// extracted by mini-css-extract-plugin
export default {"container":"Game__container--3MO","imageContainer":"Game__imageContainer--1CO","image":"Game__image--1JY","titleWrapper":"Game__titleWrapper--1lg","name":"Game__name--X84"};